import { useUserHourCycle } from "./useUserHourCycle";

export type TimeFormat = "HH:mm" | "h:mm A";

export const useTimeFormat = (): TimeFormat => {
  const cycle = useUserHourCycle();
  return cycle === "12" ? "h:mm A" : "HH:mm";
};
